// store/entities.js
import { defineStore } from 'pinia';

export const useEntityStore = defineStore('entity', {
  state: () => ({
    entities: [],
  }),
  actions: {
    setEntities(list) {
      this.entities = list;
    }
  }
});

